import { BaseScatola, BaseGridLayout } from '@lucan/base-ui'
import LineaSeparatrice from './LineaSeparatrice'
import Testo from './Testo'

export default function ScatolettaRiepilogo(props) {
  const { Icona, titolo, propsIcona, children, ...rest } = props

  return (
    <BaseScatola outlined {...rest}>
      <BaseGridLayout alignCenter spacing={1}>
        <Icona
          key='icona'
          fontSize='small'
          color='default'
          {...propsIcona}
        />
        <Testo key='testo'>{titolo}</Testo>
      </BaseGridLayout>
      
      <LineaSeparatrice />

      {children}
    </BaseScatola>
  )
}